<template>
  <div id="app">
    <indexHtml />
  </div>
</template>

<script>
import indexHtml from './components/homePage.vue'

export default {
  name: 'App',
  components: {
    indexHtml
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
